<template>
    <div>
        <header>
            <div class="header-row">
                <nav class="navbar navbar-expand">
                    <!-- Links -->
                    <ul class="navbar-nav align-items-center">
                        <li class="nav-item">
                            <a class="nav-link ex-nav-logo" href="#">
                                <img src="@/assets/img/logo_jtb_wht@2x.png" alt="Logo" class="nav-link-logo" />
                            </a>
                        </li>

                        <li class="nav-item" @click="clearPreInputVoucher()" v-if="!utils.isPwResetUser()">
                            <router-link
                            class="nav-link"
                            :class="{'active': (listCashCarry.includes(currentPage) && !$route.query.groupType)}"
                            :to="{path:'/tour/input'}"
                            refresh>
                                {{$t('header.carry_cash_details')}}
                            </router-link>
                        </li>

                        <li class="nav-item dropdown" v-if="!utils.isPwResetUser()">
                            <a class="nav-link" :class="{'active': $route.query.groupType && $route.query.groupType != constants.GroupVoucherType.non_travel.id}" data-toggle="dropdown">{{$t('header.certi_regis')}}</a>
                            <div class="dropdown-menu sub-menu">
                                <ul class="lst-btns">
                                    <li v-if="!utils.isCooperator()">
                                        <a :href='"/voucher/list?groupType=" + constants.GroupVoucherType.invoice_bill.id' class="btn btn-link-menu">
                                            {{$t('header.group.invoice_bill')}}
                                        </a>
                                    </li>
                                    <li>
                                        <a :href='"/voucher/list?groupType=" + constants.GroupVoucherType.local_expense_voucher.id' class="btn btn-link-menu" @click="clearPreInputVoucher()">{{$t('header.group.local_expense_voucher')}}</a>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li class="nav-item dropdown" v-if="utils.isAdminAndSystemAdmin()">
                            <a class="nav-link" :class="{'active': $route.query.groupType == constants.GroupVoucherType.non_travel.id}" data-toggle="dropdown">{{ $t('header.non_travel_account') }}</a>
                            <div class="dropdown-menu sub-menu">
                                <ul class="lst-btns">
                                    <li>
                                        <a :href='"/voucher/list?groupType=" + constants.GroupVoucherType.non_travel.id + "&voucherType=" + constants.VoucherType.non_travel_contract.id' class="btn btn-link-menu">{{ $t('header.non_travel_group.contract') }}</a>
                                    </li>
                                    <li>
                                        <a :href='"/voucher/list?groupType=" + constants.GroupVoucherType.non_travel.id + "&voucherType=" + constants.VoucherType.non_travel_invoice_bill.id' class="btn btn-link-menu">{{ $t('header.non_travel_group.invoice_bill') }}</a>
                                    </li>
                                    <li>
                                        <a :href='"/voucher/list?groupType=" + constants.GroupVoucherType.non_travel.id + "&voucherType=" + constants.VoucherType.non_travel_other.id' class="btn btn-link-menu">{{ $t('header.non_travel_group.other') }}</a>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li class="nav-item" v-if="utils.isAdminAndSystemAdmin() || utils.isPwResetUser() || utils.isReadOnly()">
                            <router-link
                                class="nav-link"
                                :class="[listAdminPage.includes(currentPage) ? activeClass : '']"
                                :to="{path:'/admin/users'}" exact
                            >
                                {{$t('header.menu_admin')}}
                            </router-link>
                        </li>
                        <li class="user-info-box ml-auto" v-if="user">
                            <div class="user-info">
                                <img src="@/assets/sprite/icon-user-white@2x.png" height="20"/>
                                <div class="user-name  user-ellipsis"><span>{{user.full_name}}</span></div>
                            </div>
                            <div class="user-info">
                                <div class="user-ellipsis"><span>{{user.company_name}}</span></div>
                            </div>
                            <div class="user-info">
                                <div class="user-ellipsis"><span>{{user.branch}}</span></div>
                            </div>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" href="#" @click.prevent="logout">{{$t('header.logout')}}</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
        <select-contract-modal></select-contract-modal>
    </div>
</template>
<script>
import { AuthService } from "@/services/common/auth.service";
import { Constants } from "@/helpers/constants";
import Utils from '@/helpers/utils';
import StorageService from "@/services/common/storage.service";
import SelectContractModal from '@/views/components/pc/Voucher/SelectContractModal.vue';
// import UserManagementService from '@/services/admin/user.service';

export default {
    name: "PcHeader",
    data () {
        let user = JSON.parse(StorageService.getUser());
        if(user && !Utils.isEmptyArr(user.groups)){
            user.branch = `(${user.groups[0].branch_code})${user.groups[0].branch_name}`;
            user.company_name = user.groups[0].company_name;
        }
        return {
            constants: Constants,
            utils: Utils,
            activeClass: 'active',
            currentPage: this.$router.currentRoute.path,
            listAdminPage: '/admin/users, /admin/groups, /admin/companies, /admin/dmos, /admin/doc, /admin/ocr, /admin/info',
            listCashCarry: '/tour/input, /tour/after-input, /voucher/list',
            user: user
        };
    },
    components: {
        SelectContractModal
    },
    beforeCreate () {},
    created () {
        this.getcurrentPage();
    },
    beforeMount () {},
    mounted () {
    },
    computed: {
        /*
        currentPage() {
            return this.$router.currentRoute.path;
        }
        */
    },
    watch: {
        '$route' () {
            this.getcurrentPage();
        },
    },
    methods: {
        logout (e) {
            AuthService.logout();
        },
        getcurrentPage () {
            this.currentPage = this.$router.currentRoute.path;
        },
        clearPreInputVoucher() {
            StorageService.clearPreInputVoucher();
        },
        showSelectContract () {
            $("#modalSelectContract").modal("show");
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/views/layout/pc/Header.vue